
import React, { useState } from 'react';
import styles from '../../src/assets/scss/NewUsers.module.scss';
import settingStyles from '../assets/scss/Settings/Settings.module.scss';
import Pagination from '../Components/Common/Pagination';
import { useNavigate } from 'react-router-dom';
import DeleteConfirmModal from '../Components/Common/DeleteConfirmModal';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useDeleteUserMutation, useUserRoleQuery } from '../slices/admin/admin';
import { toast } from 'react-toastify';


const NewUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [limit, setLimit] = useState(10);
  const [statusFilter, setStatusFilter] = useState('');
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  const offset = (currentPage - 1) + 1;
  const parsedIsActive =
    statusFilter === 'true' ? true :
      statusFilter === 'false' ? false : undefined;

  const { data: userData, isLoading } = useUserRoleQuery({
    offset,
    limit,
    isActive: parsedIsActive,
    search: searchTerm,
    type: userTypeFilter || undefined,
  });
  const [deleteUser] = useDeleteUserMutation();
  const [selectedUserId, setSelectedUserId] = useState(null);


  const users = userData?.result || [];


  const total = userData?.total || 0;
  const totalPages = Math.ceil(total / limit);

  const uniqueUserTypes = [...new Set(users.map(u => u.type).filter(Boolean))];

  // const handleClickUser = () => {
  //   navigate('/dashboard/User');
  // };

  const handleEditUser = (user) => {
    const bank = user.banks && user.banks.length > 0 ? user.banks[0] : {};

    navigate('/dashboard/User', {
      state: {
        mode: 'edit',
        data: {
          _id: user._id,
          userName: user.userName,
          type: user.type || '',
          firstName: user.firstName,
          lastName: user.lastName,
          isActive: user.isActive,
          phone: user.phone,
          appAccess: user.appAccess,
          deviceId: user.deviceId,
          paymentThreshold: bank.paymentThreshold || '',
          paymentType: bank.paymentType || '',
          roles: user.roles || [],
          banks: user.banks || [],
        },
      },
    });
  };

  // const handleDelete = (userId) => {
  //   setSelectedUserId(userId);
  //   setModalOpen(true);
  // };


  const confirmDelete = async () => {
    try {
      await deleteUser(selectedUserId).unwrap();
      setModalOpen(false);
      setSelectedUserId(null);
      toast.success('User deleted successfully');
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to delete user');
    }
  };


  const handleClearFilters = () => {
    setUserTypeFilter('');
    setStatusFilter('');
    setSearchTerm('');
    // setCurrentPage(1);
  };

  return (
    <div className={styles.container}>
      <div className={settingStyles.headerRow}>
        <h2 className={settingStyles.header}>Employee</h2>
      </div>
      <div className={styles.topBar}>
        <div className={styles.header}>
          <div className={styles.flex}>
            <select
              className={styles.inputs}
              value={userTypeFilter}
              onChange={(e) => {
                setUserTypeFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">All Users</option>
              {uniqueUserTypes.map((type, idx) => (
                <option key={idx} value={type}>{type}</option>
              ))}
            </select>

            <select
              className={styles.inputs}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">All Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>

            <input
              type="text"
              placeholder="Search here..."
              className={styles.searchInput}
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
            <button className={styles.clearBtn} onClick={handleClearFilters}>Clear All</button>

          </div>

          {/* <div className={styles.filterButtons}>
            <button className={styles.addBtn} onClick={handleClickUser}>+ Add New Users</button>
          </div> */}
        </div>

        <table className={styles.table}>
          <thead>
            <tr>
              {/* <th><input type="checkbox" /></th> */}
              <th>User Name</th>
              <th>User Type</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Joined Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr><td colSpan={7}>Loading...</td></tr>
            ) : users.length > 0 ? (
              users.map(user => (
                <tr key={user._id}>
                  {/* <td><input type="checkbox" /></td> */}
                  {/* <td>{user.userName}</td> */}
                  <td>{user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)} {user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</td>
                  <td>
                    <span className={`${styles.role} ${styles[user.type?.replace(/\s+/g, '').toLowerCase()]}`}>
                      {user.type || 'N/A'}
                    </span>
                  </td>
                  <td className="notranslate">{user.phone}</td>
                  <td className={user.isActive ? styles.active : styles.inactive}>
                    {user.isActive ? 'Active' : 'In Active'}
                  </td>
                  <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                  <td>
                    {/* <FaTrash className={styles.icon} onClick={() => handleDelete(user._id)} /> */}
                    <FaEdit className={styles.icon} onClick={() => handleEditUser(user)} />
                  </td>
                </tr>
              ))
            ) : (
              // <div className={styles.noData}>No records found</div>
              <tr>
                <td colSpan={7} className={styles.noData}>No records found</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
          <select
            className={styles.inputsbtn}
            value={limit}
            onChange={(e) => {
              setLimit(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>
      </div>

      <DeleteConfirmModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
      />
    </div>
  );
};

export default NewUsers;

